import { string } from 'prop-types'
import React, {useState} from 'react'
import style from './style.module.scss'

export const TooltipError = (props) => {
    return (
        <div className={style.tooltipError} style={props.style}>
            <div className={(props.rightArrow)?style.tooltipErrorArrowRight:style.tooltipErrorArrow}></div>
            <div className={style.tooltipTitle}>
                {props.text}
            </div>
        </div>
    )
}

TooltipError.defaultProps = {
    style: {},
}